var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2.5C3.5 2.22386 3.72386 2 4 2H4.5C4.77614 2 5 2.22386 5 2.5V21.5C5 21.7761 4.77614 22 4.5 22H4C3.72386 22 3.5 21.7761 3.5 21.5V2.5ZM10 6.5C10 6.22386 10.2239 6 10.5 6H16.5C16.7761 6 17 6.22386 17 6.5V7C17 7.27614 16.7761 7.5 16.5 7.5H10.5C10.2239 7.5 10 7.27614 10 7V6.5ZM10 10.5C10 10.2239 10.2239 10 10.5 10H16.5C16.7761 10 17 10.2239 17 10.5V11C17 11.2761 16.7761 11.5 16.5 11.5H10.5C10.2239 11.5 10 11.2761 10 11V10.5Z",
    fill: "#132272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 2H6.5C6.22386 2 6 2.22386 6 2.5V21.5C6 21.7761 6.22386 22 6.5 22H19C20.103 22 21 21.103 21 20V4C21 2.897 20.103 2 19 2ZM19.5 19C19.5 19.8284 18.8284 20.5 18 20.5H8C7.72386 20.5 7.5 20.2761 7.5 20V4C7.5 3.72386 7.72386 3.5 8 3.5H18C18.8284 3.5 19.5 4.17157 19.5 5V19Z",
    fill: "#132272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuManage);
export default __webpack_public_path__ + "static/media/menu-manage.4f1acbb19832984a9251ea8c7027a511.svg";
export { ForwardRef as ReactComponent };